import { useParams } from "react-router";
import { useStore } from "zustand";
import { useSignal } from "react-alien-signals";
import { useTranslation } from "react-i18next";
import AgentChat from "@/components/AgentChat";
import { usePageStore, ChatMode } from "@/stores/page";
import { cn } from "@/lib/utils";
import { initTrainingStore } from "@/stores/training";
import { type VoiceSwitchProps } from "@/components/VoiceAgentSetting";

const Modes = [ChatMode.Nav, ChatMode.Widget];

export default function AgentPreview({
  disable = false,
  inVoice
}: {
  disable?: boolean;
  inVoice?: VoiceSwitchProps;
}) {
  const { id } = useParams() as { id: string };
  const { t } = useTranslation("translations");
  const pageStore = usePageStore();
  const agentMode = useStore(pageStore, (state) => state.agentMode);
  const [trainingStore] = useSignal(initTrainingStore);
  const setPage = useStore(pageStore, (state) => state.update);

  return (
    <div className="relative box-border flex h-full max-h-full w-[34%] max-w-[560px] min-w-[356px] shrink-0 flex-col gap-4 bg-slate-100 px-6">
      {/* Widget Selector */}
      <div
        className={cn(
          "h-9 w-full shrink-0 items-center overflow-hidden rounded-md bg-white p-1.5 leading-tight text-[#5c5c5c]",
          inVoice ? "hidden" : "flex"
        )}
      >
        {Modes.map((m) => (
          <div
            className={cn(
              "h-full flex-1 cursor-pointer rounded-md text-center text-sm font-medium capitalize",
              agentMode === m && "text-primary rounded-md bg-[#eef4ff]"
            )}
            key={m}
            onClick={() => setPage("agentMode", m)}
          >
            {/* {m.split("_").join(" ")} */}
            {m === ChatMode.Widget
              ? t("widgetConfig.widget")
              : t("widgetConfig.spotlight")}
          </div>
        ))}
      </div>
      {/* Chat Widget Preview */}
      <AgentChat
        disable={disable}
        preview
        id={id}
        mode={agentMode}
        progress={trainingStore.voiceProgress || trainingStore.progress}
        inVoice={inVoice}
      />
    </div>
  );
}
